// extracted by css-extract-rspack-plugin
export default {"root":"root-jaK_jD","shadow":"shadow-RHAMF5","content":"content-TbAUzb","column":"column-a23Cds","instructions":"instructions-k4oGUd text-xl-light","spaced":"spaced-Yfy2xd"};